import React from 'react';
import { getApiTokenSelector } from "../../state/Auth"
import { createCustomer } from "../../state/Customers"
import { makeStyles, TextField, Button, Paper, Typography, Divider, Breadcrumbs } from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

// Form States
const EDITING = "EDITING"
const CREATING = "CREATING"
const CREATED = "CREATED"

const useStyles = makeStyles(theme => ({
    main: {
        padding: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
    },
    section: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    submit: {
      margin: theme.spacing(3, 0, 2),
    },
}))

const Nav = () => {
    return (
        <Breadcrumbs separator=">" aria-label="breadcrumbs">
            <Link color="inherit" to="/customers">Customers</Link>
        </Breadcrumbs>
    )
}

const NewCustomer = (props) => {

    // inputs
    const {apiToken, createCustomer} = props

    // state
    const classes = useStyles();
    const [name, setName] = React.useState("")
    const [error, setError] = React.useState("")
    const [formState, setFormState] = React.useState(EDITING)
    const [message, setMessage] = React.useState("")
    const disableSubmit = (formState !== EDITING || name.length === 0)

    // event handlers
    const onInputChange = setter => e => {
        if(error.length !== 0) {
            setError("")
        }
        setter(e.target.value)
    }

    const onSubmit = () => {
        createCustomer(
            apiToken,
            {name: name, active: true},
            error => {
                if(error?.message === "Unauthorized") {
                    // do nothing. user will get logged out
                    return
                }
                setFormState(EDITING)
                setError(error.message)
            },
            () => {
                setFormState(CREATED)
                setMessage("Customer created successfully!")
            },
        )
    }

    // JSX
    return (
        <Paper elevation={6} className={classes.main}>
            <Nav />
            <div className={classes.section}>
                <Typography variant="h4">
                    New Customer
                </Typography>
            </div>
            <Divider />
            <div className={classes.section}>
                <form
                    onSubmit={e=>{
                        e.preventDefault();
                        setFormState(CREATING)
                        onSubmit()
                    }}
                    noValidate
                >
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Name"
                        name="name"
                        autoComplete="name"
                        value={name}
                        error={error.length === 0 ? false : true}
                        helperText={error || message}
                        onChange={onInputChange(setName)}
                        disabled={formState === EDITING ? false : true}
                        autoFocus
                        />
                    {formState !== CREATED &&
                    <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={disableSubmit}
                        className={classes.submit}
                        id="create-customer"
                    >Create</Button>
                    }
                    {formState === CREATED &&
                    <Button
                        fullWidth
                        type="button"
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                        id="create-another"
                        onClick={() => {
                            setName("")
                            setError("")
                            setMessage("")
                            setFormState(EDITING)
                        }}
                    >Reset Form</Button>
                    }
                </form>
            </div>
        </Paper>
    )
}

// Redux connect
const mapStateToProps = state => {
    const apiToken = getApiTokenSelector(state)
    return {apiToken}
}
export default connect(mapStateToProps, {createCustomer})(NewCustomer)